import { FORM_NAMES } from "constants/index"
import { vendors as VENDORS } from "config"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Col, Container, Modal, Row } from "reactstrap"
import {
  getCategoryForForm,
  getProductUserTags,
  getTeaserProducts,
  getUserProfile,
  resetCategoryForForm,
  resetProductUserTags,
  resetTeaserProducts,
  resetUserProfile,
  setOrderCheckoutSession,
  submitOrderForm,
} from "store/actions"
import {
  Field,
  formValueSelector,
  initialize,
  reduxForm,
  resetSection,
} from "redux-form"
import {
  AsyncTypeahedSelect,
  CheckboxField,
  MultipleSelectField,
  TextField,
} from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import {
  emailIsValid,
  isRequiredField,
  required,
  shouldDisplayField,
} from "./utils"
import Cookies from "js-cookie"

const HarvardOrderForm = ({
  match,
  getCategoryForForm,
  resetCategoryForForm,
  categoryForForm,
  handleSubmit,
  getTeaserProducts,
  resetTeaserProducts,
  teaserProducts,
  submitOrderForm,
  nonrefundable_fees,
  terms_and_conditions,
  correct_information,
  productUserTags,
  getProductUserTags,
  resetProductUserTags,
  product,
  resetLevel,
  orderCheckoutSession,
  setOrderCheckoutSession,
  getUserProfile,
  userProfile,
  initializeForm,
  resetUserProfile,
  email,
}) => {
  const { identifier } = match?.params
  const vendor_id = VENDORS.HARVARD_CLIENT_ID
  const [userToken, setUserToken] = useState(null)

  useEffect(() => {
    if (identifier) {
      getCategoryForForm({ identifier, vendor_id })
    }
    setUserToken(Cookies.get("userToken"))
    return () => {
      resetCategoryForForm()
      resetTeaserProducts()
      resetProductUserTags()
      setOrderCheckoutSession(null)
      resetUserProfile()
    }
  }, [])

  useEffect(() => {
    if (!!userToken) {
      getUserProfile({ token: userToken })
    }
  }, [userToken])

  useEffect(() => {
    if (!!userProfile && !!categoryForForm) {
      let initValues = {}
      categoryForForm?.extra?.form_fields?.forEach(item => {
        if (
          userProfile.hasOwnProperty(item?.name) &&
          !!userProfile[item?.name]
        ) {
          initValues = { ...initValues, [item?.name]: userProfile[item?.name] }
        }
      })
      initializeForm(initValues)
    }
  }, [userProfile, categoryForForm])

  useEffect(() => {
    if (product && product?.value) {
      getProductUserTags({ vendor_id: vendor_id, product_id: product?.value })
    }
  }, [product])

  useEffect(() => {
    const timeOut = setTimeout(() => {
      getTeaserProducts({
        category: identifier,
        vendor_id: vendor_id,
        ...(!!email ? { email: email } : {}),
      })
      resetLevel()
    }, 300)

    return () => {
      clearTimeout(timeOut)
    }
  }, [email])

  const formSubmit = data => {
    const { product, ...rest } = data
    submitOrderForm({
      ...rest,
      product_id: product?.id,
      category_identifier: identifier,
      vendor_id: vendor_id,
    })
  }

  return (
    <React.Fragment>
      {!!categoryForForm && categoryForForm?.sold_out && (
        <Modal
          size="md"
          isOpen={categoryForForm?.sold_out}
          scrollable={false}
          centered={true}
        >
          <Row
            className="d-flex justify-content-center"
            style={{ height: "75px" }}
          >
            <Col xs="auto" className="align-self-center">
              <h5>Sorry, we are Sold Out!</h5>
            </Col>
          </Row>
        </Modal>
      )}
      {!!orderCheckoutSession ? (
        <OrderCheckout orderCheckoutSession={orderCheckoutSession} />
      ) : (
        <Container
          fluid
          className="d-flex justify-content-center align-items-ceter col-lg-6"
        >
          <div className="d-flex flex-column p-2 w-100">
            {categoryForForm?.banner_url && (
              <img
                src={categoryForForm?.banner_url}
                style={{ width: "100%" }}
              />
            )}
            {categoryForForm?.file_url && (
              <img src={categoryForForm?.file_url} style={{ width: "100%" }} />
            )}
            <Row className="my-3">
              <Col>
                <Field
                  name="first_name"
                  label={
                    <span>
                      First Name <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="First Name"
                  validate={[required]}
                  component={TextField}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <Field
                  name="last_name"
                  label={
                    <span>
                      Last Name <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Last Name"
                  component={TextField}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <Field
                  name="email"
                  label={
                    <span>
                      Primary Email <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Primary Email"
                  component={TextField}
                  validate={[required, emailIsValid]}
                />
              </Col>
            </Row>
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "harvard_email"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="harvard_email"
                    label={
                      <span>
                        Harvard Email (for faster verification)
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "harvard_email"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Harvard Email (for faster verification)"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "harvard_email"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "phone"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="phone"
                    label={
                      <span>
                        Mobile Number (w/County code)
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "phone"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Mobile Number (w/County code)"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "phone"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "city"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="city"
                    label={
                      <span>
                        City
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "city"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="City"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "city"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "state"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="state"
                    label={
                      <span>
                        State/Province{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "state"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="State/Province"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "state"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "country"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="country"
                    label={
                      <span>
                        Country{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "country"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Country "
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "country"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}

            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "zip_code"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="zip_code"
                    label={
                      <span>
                        Zip Code/Postal Code{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "zip_code"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Zip Code/Postal Code"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "zip_code"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "harvard_affiliation"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="harvard_affiliation"
                    label={
                      <span>
                        Harvard Affiliation (Alumni, Faculty, Staff, Student,
                        N/A){" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "harvard_affiliation"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Harvard Affiliation (Alumni, Faculty, Staff, Student, N/A)"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "harvard_affiliation"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "harvard_school_department"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="harvard_school_department"
                    label={
                      <span>
                        If you are Harvard faculty/staff - Enter the Harvard
                        school or department{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "harvard_school_department"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder=" If you are Harvard faculty/staff - Enter the Harvard
                    school or department"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "harvard_school_department"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "last_school_attended"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="last_school_attended"
                    label={
                      <span>
                        Last Harvard School Attended{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "last_school_attended"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Last Harvard School Attended"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "last_school_attended"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "degree"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="degree"
                    label={
                      <span>
                        Harvard Degree/Program
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "degree"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Harvard Degree/Program"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "degree"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "class_year"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="class_year"
                    label={
                      <span>
                        Class Year (YYYY){" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "class_year"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Class Year (YYYY)"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "class_year"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "current_situation"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="current_situation"
                    label={
                      <span>
                        Type in the role or roles that currently describe(s) you
                        (answer N/A if none apply to you): Founder / Working in
                        a Start-up / Investor / C-suite Executive
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "current_situation"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Type in the role or roles that currently describe(s) you (answer N/A if none apply to you): Founder / Working in a Start-up / Investor / C-suite Executive"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "current_situation"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "current_organisation"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="current_organisation"
                    label={
                      <span>
                        Current Organization
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "current_organisation"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Current Organization"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "current_organisation"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "title"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="title"
                    label={
                      <span>
                        Current Job Title
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "title"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Current Job Title"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "title"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "social_media"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="social_media"
                    label={
                      <span>
                        Linkedin Profile
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "social_media"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Linkedin Profile"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "social_media"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "chapter_attend_events"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="chapter_attend_events"
                    label={
                      <span>
                        Please fill in a chapter where you would like to attend
                        events
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "chapter_attend_events"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Please fill in a chapter where you would like to attend events"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "chapter_attend_events"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "guest_speaker_question"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="guest_speaker_question"
                    label={
                      <span>
                        Please submit your question for our guest speaker
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "guest_speaker_question"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Please submit your question for our guest speaker"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "guest_speaker_question"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            <Row className="my-3">
              <Col>
                <Field
                  name={"product"}
                  label={
                    <span>
                      Select
                      <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Select"
                  component={AsyncTypeahedSelect}
                  options={teaserProducts?.map(item => ({
                    value: item?.id,
                    label: `${item?.name} ${
                      item?.price > 0 ? ` - $${item?.price}` : ""
                    }`,
                    ...item,
                  }))}
                  validate={[required]}
                />
              </Col>
            </Row>
            {!!productUserTags && productUserTags?.length > 0 && (
              <Row className="my-2">
                <Col>
                  <Field
                    name="tag_ids"
                    placeholder="Select Tag"
                    label={
                      product && product?.user_tags_label
                        ? product?.user_tags_label
                        : "I am a "
                    }
                    component={MultipleSelectField}
                    options={productUserTags?.map(tag => ({
                      label: tag?.tag,
                      value: tag?.id,
                    }))}
                  />
                </Col>
              </Row>
            )}
            <Row className="mt-3">
              <Col>
                <Field
                  name="receive_newsletter"
                  component={CheckboxField}
                  label="I agree to receive the HarvardAE newsletter and administrative emails"
                />
              </Col>
            </Row>
            <Row className="my-1">
              <Col>
                <Field
                  name="terms_and_conditions"
                  component={CheckboxField}
                  label={
                    <span>
                      I agree to Terms and Conditions and Code of Conduct
                      <span className="text-danger">*</span>
                    </span>
                  }
                />
              </Col>
            </Row>
            <Row className="my-1">
              <Col>
                <Field
                  name="correct_information"
                  component={CheckboxField}
                  label={
                    <span>
                      I certify that the information provided is true and
                      correct
                      <span className="text-danger">*</span>
                    </span>
                  }
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Field
                  name="nonrefundable_fees"
                  component={CheckboxField}
                  label={
                    <span>
                      I acknowledge membership fees are nonrefundable
                      <span className="text-danger">*</span>
                    </span>
                  }
                />
              </Col>
            </Row>
            <Row className="d-flex justify-content-center ">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Join Now"
                  onClick={handleSubmit(formSubmit)}
                  disabled={
                    !correct_information ||
                    !terms_and_conditions ||
                    !nonrefundable_fees
                  }
                />
              </Col>
            </Row>
          </div>
        </Container>
      )}
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.HARVARD_ORDER_FORM)

const mapStateToProps = state => ({
  categoryForForm: state.ProductsAndSubscriptions.categoryForForm,
  teaserProducts: state.ProductsAndSubscriptions.teaserProducts,
  terms_and_conditions: selector(state, "terms_and_conditions"),
  correct_information: selector(state, "correct_information"),
  nonrefundable_fees: selector(state, "nonrefundable_fees"),
  productUserTags: state.ProductsAndSubscriptions.productUserTags,
  product: selector(state, "product"),
  orderCheckoutSession: state.ProductsAndSubscriptions.orderCheckoutSession,
  userProfile: state.Profile.userProfile,
  email: selector(state, "email"),
})

const mapDispatchToProps = dispatch => ({
  getCategoryForForm: values => dispatch(getCategoryForForm(values)),
  resetCategoryForForm: () => dispatch(resetCategoryForForm()),
  getTeaserProducts: values => dispatch(getTeaserProducts(values)),
  resetTeaserProducts: () => dispatch(resetTeaserProducts()),
  submitOrderForm: values => dispatch(submitOrderForm(values)),
  getProductUserTags: values => dispatch(getProductUserTags(values)),
  resetProductUserTags: () => dispatch(resetProductUserTags()),
  resetLevel: () =>
    dispatch(resetSection(FORM_NAMES.HARVARD_ORDER_FORM, ...["product"])),
  setOrderCheckoutSession: value => dispatch(setOrderCheckoutSession(value)),
  getUserProfile: values => dispatch(getUserProfile(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.HARVARD_ORDER_FORM, values)),
  resetUserProfile: () => dispatch(resetUserProfile()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    reduxForm({ form: FORM_NAMES.HARVARD_ORDER_FORM })(HarvardOrderForm)
  )
)
